export default __webpack_public_path__ + "static/media/empty.561bb411.svg";